import { IInvestmentStatus } from '~/@api/generated-api-types-account/Api'

const investmentStatus = {
  [IInvestmentStatus.Prereserved]: 'Rezervované',
  [IInvestmentStatus.Reserved]: 'Rezervované',
  [IInvestmentStatus.Invested]: 'Investované',
  [IInvestmentStatus.Paid]: 'Splatené',
  [IInvestmentStatus.PaidEarly]: 'Predčasne splatené',
  [IInvestmentStatus.Cancelled]: 'Zrušené',
  [IInvestmentStatus.Withdrawn]: 'Odstúpil od zmluvy',
  [IInvestmentStatus.Extended]: 'V maximálnej dobe splatnosti',
  [IInvestmentStatus.Delayed]: 'Omeškané',
}

export function getInvestmentStatusLabel(key: IInvestmentStatus) {
  return investmentStatus[key]
}
